module.exports = new __parcel__URL__("unsupported.afc195d1.svg").toString();